exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fl-indicator .radio.checked label div:nth-child(2){color:#fff}.fl-indicator .fl-tooltip{font-weight:600;position:absolute!important;width:120px;line-height:21px;padding:10px;font-size:16px;color:#fff;letter-spacing:0}.fl-indicator label div:nth-child(2){font-weight:400;color:#aeaeae;letter-spacing:1.02px}@media(min-width:768px){.fl-indicator label div:nth-child(2){font-size:12px}}@media(max-width:767px){.fl-indicator label div:nth-child(2){font-size:10px}}", ""]);

// exports
